import { deepCopy, flatten } from '@newgenus/common';
import { Injectable } from '@angular/core';


/**
 *  Previously named "org-flat-object-builder.service.ts" / "OrgFlatObjectBuilderService".
 */
@Injectable({
    providedIn: 'root'
})
export class TreeBuilderService {
    public orgs: any[] = [];
    public orgParts: any[] = [];
    public org: any = {};

    public partsSwatch: any = {
        org: {
            color: 'white',
            background: 'red',
        },
        securityGroup: {
            color: 'white',
            background: 'green',
        },
        hat: {
            color: 'white',
            background: 'yellow',
        },
        feature: {
            color: 'white',
            background: 'blue',
        },
        featureDetails: {
            color: 'white',
            background: '#6060f4',
        },
        permission: {
            color: 'white',
            background: '#6060f4',
        },
        role: {
            color: 'white',
            background: 'yellow',
        },
        user: {
            color: 'white',
            background: '#c2185b',
        },
        orgSecurityGroupsSubCollection: {
            color: 'black',
            background: '#04d704',
        },
        userOnOtherSecurityGroupsWithSamePosition: {
            color: 'white',
            background: '#4d1c2f',
        },
        securityGroupsOnPositionObject: {
            color: 'black',
            background: '#04d704',
        },

    };

    public securityGroupObject: any = null;
    public hatObject: any = null;
    public securityGroupsTreeObjectForOrgSecurityGroups: any = {}; // All the securityGroups for the selected org derived from org doc - orgSecurityGroups object

    constructor(
    ) {
        // Add constructor code here
    }


    public fetchColor(type: string) {
        const color = this.partsSwatch[type].color;
        return color;
    }

    public fetchBackground(type: string) {
        const background = this.partsSwatch[type].background;
        return background;
    }

    public setSecurityGroupsTreeObject(childObjectArray: any, org: any, securityGroup: any, tree: string) {

        if (this.securityGroupObject === null || this.securityGroupObject === undefined) {

            this.securityGroupObject = {
                selected: true,
                color: this.fetchColor('securityGroup'),
                background: this.fetchBackground('securityGroup'),
                data: {
                    depth: 1,
                    key: securityGroup.key,
                    expandedKey: tree + "-" + org.key + "-" + securityGroup.key,
                    name: securityGroup.name,
                    multiUsers: securityGroup.multiUsers,
                    type: 'securityGroup'
                },
                children: [],
            };

        }

        this.securityGroupObject.children.push(childObjectArray);

        return this.securityGroupObject;
    }

    public setHatsTreeObject(childObjectArray: any, org: any, hat: any, tree: string) {

        if (this.hatObject === null || this.hatObject === undefined) {

            this.hatObject = {
                selected: true,
                color: this.fetchColor('hat'),
                background: this.fetchBackground('hat'),
                data: {
                    depth: 1,
                    key: hat.key,
                    expandedKey: tree + "-" + org.key + "-" + hat.key,
                    name: hat.name,
                    multiUsers: hat.multiUsers,
                    type: 'hat'
                },
                children: [],
            };

        }

        this.hatObject.children.push(childObjectArray);

        return this.hatObject;
    }

    public buildTreeObjectForAllFeaturesAndPermissionsOfSecurityGroup(org: any, securityGroup: any, tree: string) {
        const orgKey = org.key;
        const securityGroupObjectArray: any = [];
        // console.log('org >>>>>: ', org);
        // console.log('securityGroup >>>>>: ', securityGroup);
        for (const securityGroupKey of org.orgSecurityGroups.securityGroupsKeys) {
            const securityGroupFeatureObjectArray: any = [];
            // console.log('securityGroupKey >>>>>: ', securityGroupKey);
            // console.log('org.orgSecurityGroups[securityGroupKey].key >>>>>: ', org.orgSecurityGroups[securityGroupKey].key);
            // console.log('securityGroup.key >>>>>: ', securityGroup.key);
            
            const test = org.orgSecurityGroups[securityGroupKey].key === securityGroup.key;
            // console.log('test >>>>>: ', test);
            
            let foundSecurityGroup = undefined;
            if(test)   {
                // console.log("org.orgSecurityGroups[securityGroupKey] ", JSON.stringify(org.orgSecurityGroups[securityGroupKey]));
                foundSecurityGroup = org.orgSecurityGroups[securityGroupKey];
            }
            // const foundSecurityGroup = org.orgSecurityGroups[securityGroupKey].key === securityGroup.key ? org.securityGroups[securityGroupKey] : undefined;

            // console.log('foundSecurityGroup >>>>>: ', foundSecurityGroup);
            if (foundSecurityGroup) {

                for (const featureKey of foundSecurityGroup.features) {
                    const featureDetail = foundSecurityGroup.featureDetails[featureKey];
                    const featureObject: any = {
                        selected: true,
                        color: this.fetchColor('feature'),
                        background: this.fetchBackground('feature'),
                        data: {
                            depth: 2,
                            key: featureKey,
                            expandedKey: tree + "-" + orgKey + "-" + foundSecurityGroup.key + "-" + securityGroupKey + "-" + featureKey,
                            name: featureKey,
                            type: 'feature'
                        },
                        children: [
                            {
                                selected: true,
                                color: this.fetchColor('featureDetails'),
                                background: this.fetchBackground('featureDetails'),
                                data: {
                                    depth: 2,
                                    key: 'featureDetails-' + featureKey,
                                    expandedKey: tree + "-" + orgKey + "-" + foundSecurityGroup.key + "-" + 'featureDetails-' + securityGroupKey + "-" + featureKey,
                                    name: featureDetail.permissions,
                                    type: 'featureDetails',
                                },
                            },
                        ],
                    };
                    securityGroupFeatureObjectArray.push(featureObject);
                }
                const securityGroupObject: any = {
                    selected: true,
                    color: this.fetchColor('securityGroup'),
                    background: this.fetchBackground('securityGroup'),
                    data: {
                        depth: 2,
                        key: securityGroup.key,
                        expandedKey: tree + "-" + orgKey + "-" + foundSecurityGroup.key + "-orgSecurityGroups-" + securityGroup.key,
                        name: securityGroup.name,
                        multiUsers: securityGroup.multiUsers,
                        type: 'securityGroup'
                    },
                    children: securityGroupFeatureObjectArray,
                };
                securityGroupObjectArray.push(securityGroupObject);
            }
        }

        // All the securityGroups for the selected position derived from org doc - orgSecurityGroups object
        const securityGroupsForOrgSecurityGroupsObject: any = {
            selected: true,
            color: this.fetchColor('securityGroup'),
            background: this.fetchBackground('securityGroup'),
            data: {
                depth: 2,
                key: securityGroup.key + "-" + org.key + "-orgSecurityGroups",
                expandedKey: tree + "-" + orgKey + "-" + securityGroup.key + "-orgSecurityGroups",
                name: 'orgSecurityGroups for ' + securityGroup.key,
                type: 'securityGroups'
            },
            children: securityGroupObjectArray,
        };

        return securityGroupsForOrgSecurityGroupsObject;
    }

    public buildTreeObjectForAllFeaturesAndPermissionsOfSecurityGroup2(orgSecurityGroupsSubColObject: any, org: any, securityGroup: any, tree: string) {
        const securityGroupObjectArray2: any = [];
        for (const securityGroup of orgSecurityGroupsSubColObject) {
            const orgSecurityGroupsSubColFeatureObject = [];

            for (const featureKey in securityGroup.featureDetails) {
                const feature = securityGroup.featureDetails[featureKey];

                const featureObject: any = {
                    selected: true,
                    color: this.fetchColor('feature'),
                    background: this.fetchBackground('feature'),
                    data: {
                        depth: 2,
                        key: featureKey,
                        expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key + "-" + featureKey + "-orgSecurityGroupsSubCol",
                        name: featureKey,
                        type: 'feature'
                    },
                    children: [
                        {
                            selected: true,
                            color: this.fetchColor('featureDetails'),
                            background: this.fetchBackground('featureDetails'),
                            data: {
                                depth: 2,
                                key: featureKey,
                                expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key + "-" + featureKey + "-featureDetails" + "-orgSecurityGroupsSubCol",
                                name: feature.permissions,
                                type: 'featureDetails',
                            },
                            children: [],
                        },
                    ],
                };
                orgSecurityGroupsSubColFeatureObject.push(featureObject);
            }

            const securityGroupObject: any = {
                selected: true,
                color: this.fetchColor('securityGroup'),
                background: this.fetchBackground('securityGroup'),
                data: {
                    depth: 2,
                    key: securityGroup.key,
                    expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key,
                    name: securityGroup.name,
                    multiUsers: securityGroup.multiUsers,
                    type: 'securityGroup'
                },
                children: orgSecurityGroupsSubColFeatureObject,
            };
            securityGroupObjectArray2.push(securityGroupObject);
        }

        // All the securityGroups for the selected position derived from org securityGroups sub-collection
        const orgSecurityGroupsSubCollectionsObject: any = {
            selected: true,
            color: this.fetchColor('orgSecurityGroupsSubCollection'),
            background: this.fetchBackground('orgSecurityGroupsSubCollection'),
            data: {
                depth: 2,
                key: securityGroup.key,
                expandedKey: tree + "-" + org.key + "-" + securityGroup.key + "-orgSecurityGroupsSubCol",
                name: 'Org securityGroups Sub-Collections ' + securityGroup.key,
                type: 'orgSecurityGroupsSubCollection',
            },
            children: securityGroupObjectArray2,
        };

        return orgSecurityGroupsSubCollectionsObject;
    }

    public extractAllOrgUsersForPosition(userDetails: any, org: any, securityGroup: any, tree: string) {
        const userKeysOnSecurityGroup: any = [];
        if (securityGroup.multiUsers && securityGroup.multiUsersArray > 0) {
            userKeysOnSecurityGroup.push(...securityGroup.multiUsersArray);
        } else {
            userKeysOnSecurityGroup.push(securityGroup.assignedTo);
        }

        const userDetailsArray: any = [];
        for (const userKey of userKeysOnSecurityGroup) {
            // get user details and create user object
            const user = userDetails.users.find((o: any) => {
                if (o.uid === userKey) {
                    return o;
                }
            });

            const userDetailsObject: any = {
                selected: true,
                color: this.fetchColor('user'),
                background: this.fetchBackground('user'),
                data: {
                    depth: 1,
                    key: userKey,
                    expandedKey: tree + "-" + org.key + "-" + securityGroup.key + "-" + userKey,
                    name: user?.name || userKey,
                    type: 'user'
                },
                children: [],
            };

            userDetailsArray.push(userDetailsObject);
        }

        const usersOnSecurityGroup: any = {
            selected: true,
            color: this.fetchColor('user'),
            background: this.fetchBackground('user'),
            data: {
                depth: 1,
                key: "userOnSecurityGroup: " + securityGroup.key,
                expandedKey: tree + "-" + org.key + "-" + securityGroup.key + "userOnSecurityGroup",
                name: "Users on securityGroup: " + securityGroup.key,
                type: 'usersOnSecurityGroup'
            },
            children: userDetailsArray,
        };

        return usersOnSecurityGroup;
    }

    public extractUsersWithSamePositionOnOtherSecurityGroups(userDetails: any, org: any, securityGroup: any, tree: string) {

        // Find other securityGroups in securityGroups sub collections with same position as selected securityGroup
        const securityGroupsWithSamePositionArray: any = this.getSecurityGroupsWithSamePosition(org, securityGroup);

        const securityGroupsWithSamePositionObjectArray: any = [];
        for (const securityGroupWithPosition of securityGroupsWithSamePositionArray) {
            // get user keys from the securityGroupWithPosition
            const userKeysOnSecurityGroup: any = [];
            if (securityGroupWithPosition.multiUsers && securityGroupWithPosition.multiUsersArray > 0) {
                userKeysOnSecurityGroup.push(...securityGroupWithPosition.multiUsersArray);
            } else {
                userKeysOnSecurityGroup.push(securityGroupWithPosition.assignedTo);
            }

            // create user objects
            const userDetailsArray: any = [];
            for (const userKey of userKeysOnSecurityGroup) {
                // get user details and create user object
                const user = userDetails.users.find((o: any) => {
                    if (o.uid === userKey) {
                        return o;
                    }
                });
                // console.log("user *********************: ", user);

                const userDetailsObject: any = {
                    selected: true,
                    color: this.fetchColor('user'),
                    background: this.fetchBackground('user'),
                    data: {
                        depth: 1,
                        key: userKey,
                        expandedKey: tree + "-" + org.key + "-" + securityGroupWithPosition.key + "-" + userKey,
                        name: user?.name || userKey,
                        type: 'user'
                    },
                    children: [],
                };

                userDetailsArray.push(userDetailsObject);
            }

            const securityGroupObject: any = {
                selected: true,
                color: this.fetchColor('securityGroup'),
                background: this.fetchBackground('securityGroup'),
                data: {
                    depth: 1,
                    key: securityGroupWithPosition.key,
                    expandedKey: tree + "-" + org.key + "-" + securityGroupWithPosition.key,
                    name: securityGroupWithPosition.name,
                    type: 'securityGroup'
                },
                children: userDetailsArray,
            };
            securityGroupsWithSamePositionObjectArray.push(securityGroupObject);
        }

        const userOnOtherSecurityGroupsWithSamePosition: any = {
            selected: true,
            color: this.fetchColor('userOnOtherSecurityGroupsWithSamePosition'),
            background: this.fetchBackground('userOnOtherSecurityGroupsWithSamePosition'),
            data: {
                depth: 1,
                key: "userOnOtherSecurityGroupsWithSamePosition: " + securityGroup.key,
                expandedKey: tree + "-" + org.key + "-" + securityGroup.key + "userOnOtherSecurityGroupsWithSamePosition",
                name: "Users on Other securityGroups with same Position: " + securityGroup.key,
                type: 'userOnOtherSecurityGroupsWithSamePosition'
            },
            children: securityGroupsWithSamePositionObjectArray,
        };

        return userOnOtherSecurityGroupsWithSamePosition;
    }

    public buildTreeObjectForAllSecurityGroupsForPositions(positionsCopy: any, partToStartFromPathSplitString: string, org: any, orgKey: any, securityGroup: any, tree: string) {
        // console.log('buildTreeObjectForAllSecurityGroupsForPositions > positionsCopy', positionsCopy)
        for (let i = 0; i < positionsCopy.length; i++) {
            const path = positionsCopy[i].path;
            const name = positionsCopy[i].name;

            let pathSplitString = "";

            pathSplitString = path.substring(partToStartFromPathSplitString.length, path.length);

            const partData = {
                background: "#007bff",
                color: "white",
                selected: true,
            };
            positionsCopy[i].levelUp = partData;
            positionsCopy[i].path = pathSplitString;
            positionsCopy[i].type = 'positionsPartsRelationship';
            positionsCopy[i].expandedKey = 'tree5-' + securityGroup.key + 'positionsPartsRelationship-' + pathSplitString;

            // find and attach all securityGroups to the position
            const securityGroupsForPosition: any = [];
            for (const securityGroupKey of org.orgSecurityGroups.securityGroupsKeys) {
                const securityGroupSearch = org.orgSecurityGroups[securityGroupKey];
                if (securityGroupSearch.orgPosition.partKey === positionsCopy[i].partKey) {
                    securityGroupsForPosition.push(securityGroupSearch);
                }
            }

            positionsCopy[i].securityGroupsArray = securityGroupsForPosition;

            const securityGroupObjectArray2: any = [];
            for (const securityGroup of securityGroupsForPosition) {
                const orgSecurityGroupsSubColFeatureObject = [];

                for (const featureKey in securityGroup.featureDetails) {
                    const feature = securityGroup.featureDetails[featureKey];

                    const featureObject: any = {
                        selected: true,
                        color: this.fetchColor('feature'),
                        background: this.fetchBackground('feature'),
                        data: {
                            depth: 2,
                            key: featureKey,
                            expandedKey: tree + "-" + orgKey + "-" + "-" + securityGroup.key + "-" + featureKey + "-orgSecurityGroupsSubCol",
                            name: featureKey,
                            type: 'feature'
                        },
                        children: [
                            {
                                selected: true,
                                color: this.fetchColor('featureDetails'),
                                background: this.fetchBackground('featureDetails'),
                                data: {
                                    depth: 2,
                                    key: featureKey,
                                    expandedKey: tree + "-" + orgKey + "-" + "-" + securityGroup.key + "-" + featureKey + "-featureDetails" + "-orgSecurityGroupsSubCol",
                                    name: feature.permissions,
                                    type: 'featureDetails',
                                },
                                children: [],
                            },
                        ],
                    };
                    orgSecurityGroupsSubColFeatureObject.push(featureObject);
                }

                if (orgSecurityGroupsSubColFeatureObject.length > 0) {
                    const securityGroupObject: any = {
                        selected: true,
                        color: this.fetchColor('securityGroup'),
                        background: this.fetchBackground('securityGroup'),
                        data: {
                            depth: 2,
                            key: securityGroup.key,
                            expandedKey: tree + "-" + orgKey + "-" + "-" + securityGroup.key,
                            name: securityGroup.name,
                            multiUsers: securityGroup.multiUsers,
                            type: 'securityGroup'
                        },
                        children: orgSecurityGroupsSubColFeatureObject,
                    };

                    securityGroupObjectArray2.push(securityGroupObject);
                }

            }

            if (securityGroupObjectArray2.length > 0) {
                const securityGroupsOnPositionObject: any = {
                    selected: true,
                    color: this.fetchColor('securityGroupsOnPositionObject'),
                    background: this.fetchBackground('securityGroupsOnPositionObject'),
                    data: {
                        depth: 2,
                        key: positionsCopy[i].name,
                        expandedKey: tree + "-" + orgKey + "-" + securityGroup.key + "-securityGroupsOnPositionObject",
                        name: 'Org securityGroups on Position: ** ' + positionsCopy[i].name + " **",
                        type: 'securityGroupsOnPositionObject',
                    },
                    children: securityGroupObjectArray2,
                };


                const flattenSecurityGroupsObject = flatten(securityGroupsOnPositionObject);

                positionsCopy[i].securityGroupsFlat = flattenSecurityGroupsObject;

                positionsCopy[i].securityGroupsObject = securityGroupsOnPositionObject;
            } else {
                positionsCopy[i].securityGroupsFlat = {};

                positionsCopy[i].securityGroupsObject = {};
            }
        }

        return positionsCopy;
    }

    public buildSecurityGroupsRelationshipsObject(positionsCopy: any, partToStartFromPathSplitString: string, org: any, securityGroup: any, tree: string) {
        for (let i = 0; i < positionsCopy.length; i++) {
            const path = positionsCopy[i].path;
            const name = positionsCopy[i].name;

            let pathSplitString = "";

            pathSplitString = path.substring(partToStartFromPathSplitString.length, path.length);

            const partData = {
                background: "#007bff",
                color: "white",
                selected: true,
            };

            const inheritedSecurityGroupsForPosition = positionsCopy[i].inheritanceObjects.secondaryPositionSecurityGroups;
            positionsCopy[i].inheritedSecurityGroupsForPosition = inheritedSecurityGroupsForPosition;

            const securityGroupObjectArray2: any = [];
            for (const securityGroup of inheritedSecurityGroupsForPosition) {
                const orgSecurityGroupsSubColFeatureObject = [];

                for (const featureKey in securityGroup.featureDetails) {

                    const feature = securityGroup.featureDetails[featureKey];

                    const featureObject: any = {
                        selected: true,
                        color: 'white',
                        background: 'blue',
                        data: {
                            depth: 2,
                            key: featureKey,
                            expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key + "-" + featureKey + "-orgSecurityGroupsSubCol",
                            name: featureKey,
                            type: 'feature'
                        },
                        children: [
                            {
                                selected: true,
                                color: 'white',
                                background: 'blue',
                                data: {
                                    depth: 2,
                                    key: featureKey,
                                    expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key + "-" + featureKey + "-featureDetails" + "-orgSecurityGroupsSubCol",
                                    name: feature.permissions,
                                    type: 'featureDetails',
                                },
                                children: [],
                            },
                        ],
                    };
                    orgSecurityGroupsSubColFeatureObject.push(featureObject);
                }


                if (orgSecurityGroupsSubColFeatureObject.length > 0) {
                    const securityGroupObject: any = {
                        selected: true,
                        color: 'white',
                        background: 'green',
                        data: {
                            depth: 2,
                            key: securityGroup.key,
                            expandedKey: tree + "-" + org.key + "-" + "-" + securityGroup.key,
                            name: securityGroup.name,
                            multiUsers: securityGroup.multiUsers,
                            type: 'securityGroup'
                        },
                        children: orgSecurityGroupsSubColFeatureObject,
                    };

                    securityGroupObjectArray2.push(securityGroupObject);
                }

            }

            if (securityGroupObjectArray2.length > 0) {
                const securityGroupsOnPositionObject: any = {
                    selected: true,
                    color: 'black',
                    background: '#e402e4',
                    data: {
                        depth: 2,
                        key: positionsCopy[i].name,
                        expandedKey: tree + "-" + org.key + "-" + securityGroup.key + "-inheritedSecurityGroupsOnPositionObject",
                        name: 'Org Inherited securityGroups on Position: ** ' + positionsCopy[i].name + " **",
                        type: 'inheritedSecurityGroupsOnPositionObject',
                    },
                    children: securityGroupObjectArray2,
                };

                // console.log("securityGroupsOnPositionObject : ", securityGroupsOnPositionObject);

                const flattenInheritedSecurityGroupsObject = flatten(securityGroupsOnPositionObject);

                // console.log("flattenInheritedSecurityGroupsObject : ", flattenInheritedSecurityGroupsObject);
                positionsCopy[i].inheritedSecurityGroupsFlat = flattenInheritedSecurityGroupsObject;

                positionsCopy[i].inheritedSecurityGroupsObject = securityGroupsOnPositionObject;
            } else {
                positionsCopy[i].inheritedSecurityGroupsFlat = {};

                positionsCopy[i].inheritedSecurityGroupsObject = {};
            }
        }
    }

    public getSecurityGroupsWithSamePosition(org: any, securityGroup: any) {
        const securityGroupsWithSamePositionArray: any = [];
        for (const securityGroupKey of org.orgSecurityGroups.securityGroupsKeys) {
            const securityGroupSearch = org.orgSecurityGroups[securityGroupKey];
            if (securityGroup.orgPosition.key === securityGroupSearch.orgPosition.key && securityGroup.key !== securityGroupSearch.key) {
                securityGroupsWithSamePositionArray.push(securityGroupSearch);
            }
        }
        return securityGroupsWithSamePositionArray;
    }

    public appendAllChildPositionsToOrgParts(orgParts: any, securityGroup: any) {
        // console.log('🔍 DEBUG: appendAllChildPositionsToOrgParts called with:', {
        //     orgPartsCount: orgParts?.length,
        //     startingPart: securityGroup?.orgPosition?.name,
        //     startingPartKey: securityGroup?.orgPosition?.partKey,
        //     startingDepth: securityGroup?.orgPosition?.depth
        // });

        let process = true;
        const firstPart = securityGroup.orgPosition;
        let children = orgParts.filter((o: any) => o.depth === firstPart?.depth + 1 && o.parentPartKey === firstPart?.partKey);

        // console.log('🔍 DEBUG: Initial direct children found:', {
        //     count: children.length,
        //     children: children.map((c: any) => ({
        //         name: c.name,
        //         partKey: c.partKey,
        //         depth: c.depth,
        //         parentPartKey: c.parentPartKey,
        //         partType: c.partType
        //     }))
        // });

        const positionsWillInheritFromSecurityGroupAbove2: any = [];
        positionsWillInheritFromSecurityGroupAbove2.push(firstPart);
        positionsWillInheritFromSecurityGroupAbove2.push(...children);

        let children2: any = [];
        let childsChildren: any = [];
        let depthLevel = firstPart?.depth + 1;
        
        while (process) {
            // console.log(`🔍 DEBUG: Processing depth level ${depthLevel + 1}, current children count: ${children.length}`);

            children2 = [];
            for (const child of children) {
                // console.log(`🔍 DEBUG: Looking for children of "${child.name}" (depth ${child.depth + 1})`);
                
                childsChildren = orgParts.filter((o: any) => o.depth === child?.depth + 1 && o.parentPartKey === child?.partKey);
                
                // console.log(`🔍 DEBUG: Found ${childsChildren.length} children for "${child.name}":`, 
                //     childsChildren.map((c: any) => ({
                //         name: c.name,
                //         partKey: c.partKey,
                //         depth: c.depth,
                //         partType: c.partType
                //     }))
                // );
                
                children2.push(...childsChildren);
                positionsWillInheritFromSecurityGroupAbove2.push(child);
            }

            // console.log(`🔍 DEBUG: Total children found at depth ${depthLevel + 1}: ${children2.length}`);
            
            if (children2.length > 0) {
                // more children to process
                children = children2;
                depthLevel++;
            } else {
                // console.log('🔍 DEBUG: No more children found, stopping traversal');
                process = false;
            }
        }

        // remove duplicates on positionsWillInheritFromSecurityGroupAbove2
        const positionsWillInheritFromSecurityGroupAboveNoDuplicates2: any = [];
        for (const position of positionsWillInheritFromSecurityGroupAbove2) {
            if (!positionsWillInheritFromSecurityGroupAboveNoDuplicates2.find((o: any) => o.partKey === position.partKey)) {
                positionsWillInheritFromSecurityGroupAboveNoDuplicates2.push(position);
            }
        }

        // console.log('🔍 DEBUG: Final result from appendAllChildPositionsToOrgParts:', {
        //     totalCount: positionsWillInheritFromSecurityGroupAboveNoDuplicates2.length,
        //     byDepth: positionsWillInheritFromSecurityGroupAboveNoDuplicates2.reduce((acc: any, pos: any) => {
        //         acc[pos.depth] = acc[pos.depth] || [];
        //         acc[pos.depth].push({ name: pos.name, partType: pos.partType });
        //         return acc;
        //     }, {})
        // });

        // console.log("🚀 ~ TreeBuilderService ~ appendAllChildPositionsToOrgParts ~ positionsWillInheritFromSecurityGroupAboveNoDuplicates2:", positionsWillInheritFromSecurityGroupAboveNoDuplicates2)
        return positionsWillInheritFromSecurityGroupAboveNoDuplicates2;
    }

    public positionsWillInheritFromSecurityGroupBelow(org: any, securityGroup: any) {

        let process = true
        const orgParts = org.orgParts;
        let securityGroupPosition = securityGroup.orgPosition;
        const positionsWillInheritFromSecurityGroupBelow: any = [];
        while (process) {
            const position = orgParts.find((o: any) => o.partKey === securityGroupPosition?.parentPartKey);
            if (position) {
                positionsWillInheritFromSecurityGroupBelow.push(position);
                securityGroupPosition = position;
            } else {
                process = false;
            }

        }

        return positionsWillInheritFromSecurityGroupBelow;
    }

    public extractSecurityGroupsForInheritedPositions(positionsCopy: any) {
        const inheritanceObject: any = {};
        const inheritanceObjects: any = {};
        
        for (const part of positionsCopy) {

            // place all the securityGroups of the primary part into object
            inheritanceObject.primaryPositionSecurityGroups = part.securityGroupsArray;

            // work through every child of part down
            const { positionsWillInheritFromSecurityGroupAbove, childrenSecurityGroups } = this.processAllChildrenAndGetSecurityGroups(part, positionsCopy);

            // place all the securityGroups of the secondary parts into object
            inheritanceObject.secondaryPositionSecurityGroups = childrenSecurityGroups;


            part.inheritanceObjects = deepCopy(inheritanceObject);
            inheritanceObjects[part.name] = deepCopy(inheritanceObject);
        }
    }

    public processAllChildrenAndGetSecurityGroups(orgPosition: any, orgParts: any) {
        let process = true;
        const firstPart = orgPosition;
        let children = orgParts.filter((o: any) => o.depth === firstPart?.depth + 1 && o.parentPartKey === firstPart?.partKey);

        const positionsWillInheritFromSecurityGroupAbove = [];
        positionsWillInheritFromSecurityGroupAbove.push(firstPart);
        positionsWillInheritFromSecurityGroupAbove.push(...children);

        let children2 = [];
        let childsChildren = [];
        const childrenSecurityGroups = [];
        while (process) {

            // console.log("children 2 : ", children);
            children2 = [];
            for (const child of children) {

                childsChildren = orgParts.filter((o: any) => o.depth === child?.depth + 1 && o.parentPartKey === child?.partKey);
                children2.push(...childsChildren);

                // process the child and get all the securityGroups of its children
                childrenSecurityGroups.push(...child.securityGroupsArray);
                positionsWillInheritFromSecurityGroupAbove.push(child);

            }

            if (children2.length > 0) {
                // more children to process
                children = children2;
            } else {
                process = false;
            }

        }
        return { positionsWillInheritFromSecurityGroupAbove, childrenSecurityGroups };
    }



}
